import "./App.css";
import "./plugins/i18n";
// import "antd/dist/antd.css";
import { isTMA } from "@telegram-apps/bridge";
import { init, postEvent } from "@telegram-apps/sdk-react";
import "animate.css";
import "antd/dist/antd.min.css";
import { SnackbarProvider } from "notistack";
import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import Helmet from "react-helmet";
import { useTranslation } from "react-i18next";
import { httpClient } from "./apis/https";
import FontSetting from "./components/FontSetting";

import Context from "./context";
import { platformAdScript } from "./externalScript";
import { useOkSpinPixel } from "./hooks/okSpinPixel/okSpinPixel.hooks";
import { usePwaInstall } from "./hooks/pwaInstall/usePwaInstall.hooks";
import { envChangeType } from "./plugins/utils";
import RouterRender from "./router";

const currentTheme = require(
  `./theme/${envChangeType("REACT_APP_PRODUCTION_NAME_DEV")}/theme.json`,
);
const defaultTheme = require(`./theme/defaultTheme.json`);
const finalTheme = { ...defaultTheme, ...currentTheme };
const initializedGtmIds = new Set();

const hasInjectedGtm = (gtmId) => {
  if (initializedGtmIds.has(gtmId)) return true;

  return Boolean(document.querySelector(`script[src*="googletagmanager.com/gtm.js?id=${gtmId}"]`));
};

function App() {
  const { t } = useTranslation();
  const [vh, setVh] = useState(1);
  const { isStandalone, installSource } = usePwaInstall();
  const { pushEvent, isHaveOkSpinPixel } = useOkSpinPixel();

  const setTheme = () => {
    const r = document.querySelector(":root");
    const final = Object.entries(finalTheme);
    final.map((color) => {
      r.style.setProperty(color[0], color[1]);
    });
  };
  useEffect(() => {
    setTheme();
  }, [finalTheme]);

  const initGTAG = () => {
    const gcode = envChangeType("REACT_APP_GCODE");
    if (gcode === "" || gcode === null || gcode === undefined) return;
    gcode
      .split(",")
      .map((id) => id.trim())
      .filter(Boolean)
      .forEach((gtmId) => {
        if (hasInjectedGtm(gtmId)) return;

        TagManager.initialize({
          gtmId,
        });
        initializedGtmIds.add(gtmId);
      });
  };

  const initStyle = () => {
    let _vh = window.innerHeight * 0.01;
    setVh(_vh);
    window.document.documentElement.style.setProperty("--vh", `${_vh}px`);
    window.document.documentElement.style.setProperty("background", `#f5f5f5`);
  };

  useEffect(() => {
    initStyle();
    initGTAG();
  }, []);

  useEffect(() => {
    // Check if the app is running inside Telegram
    if (isTMA()) {
      // Call init() only if the environment is Telegram
      init();

      // postEvent("web_app_exit_fullscreen");
      postEvent("web_app_expand");

      // const removeListener = on("viewport_changed", (payload) => {
      //   setText(JSON.stringify(payload.height));
      //   if (!payload.is_fullscreen) {
      //     window.location.reload();
      //   }
      // });

      // return () => {
      //   removeListener();
      // };
    }
  }, []);

  /**
   * SCROLL TESTING PURPOSE
   * DO NOT DELETE, OPEN WHEN DEBUG SCROLL ISSUE ONLY
   */
  // function isScrollable(el) {
  //   return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
  // }
  // window.addEventListener(
  //   "scroll",
  //   function (e) {
  //     var el = e.target;
  //     while (el && el !== document && !isScrollable(el)) {
  //       el = el.parent;
  //     }
  //     console.debug("Scrolled element: " + (el.className || "document"));
  //   },
  //   true,
  // );

  const renderScript = () => {
    if (envChangeType("REACT_APP_HEAD_FBPIXEL_ID")) {
      const pixelArray = envChangeType("REACT_APP_HEAD_FBPIXEL_ID").split(",");
      return (
        <Helmet>
          <script type="text/javascript">
            {platformAdScript["FBpixel"].script({ id: pixelArray })}
          </script>
        </Helmet>
      );
    }
    if (envChangeType("REACT_APP_HEAD_51LA_ID")) {
      return (
        <Helmet>
          <script type="text/javascript">
            {platformAdScript["51la"].script({ id: envChangeType("REACT_APP_HEAD_51LA_ID") })}
          </script>
        </Helmet>
      );
    }
  };
  const renderNoScript = () => {
    if (envChangeType("REACT_APP_HEAD_FBPIXEL_ID")) {
      const pixelArray = envChangeType("REACT_APP_HEAD_FBPIXEL_ID").split(",");
      return (
        <Helmet>
          <noscript>{platformAdScript["FBpixel"].noscript({ id: pixelArray })}</noscript>
        </Helmet>
      );
    }
  };
  const renderFBVerifyMeta = () => {
    if (envChangeType("REACT_APP_HEAD_FBVERIFY_CONTENT")) {
      return (
        <Helmet
          meta={[
            {
              name: "facebook-domain-verification",
              content: envChangeType("REACT_APP_HEAD_FBVERIFY_CONTENT"),
            },
          ]}
        />
      );
    }
  };

  const renderNoIndex = () => {
    if (process.env.REACT_APP_ENV !== "production") {
      return <Helmet meta={[{ name: "robots", content: "noindex" }]} />;
    }
  };

  useEffect(() => {
    httpClient.translateFn = t;
  }, [t]);

  useEffect(() => {
    if (isStandalone && isHaveOkSpinPixel) {
      pushEvent({
        eventName: "EVENT_PWA_OPEN",
        properties: {
          content_type: "product",
          content_name: "PWA開啟",
          content_category: installSource?.platform || "",
        },
      });
    }
  }, [isStandalone, isHaveOkSpinPixel, installSource]);

  return (
    <div id="app" className="app">
      {renderScript()}
      {renderNoScript()}
      {renderFBVerifyMeta()}
      {renderNoIndex()}
      <SnackbarProvider
        anchorOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <Context>
          <FontSetting />
          <RouterRender />
        </Context>
      </SnackbarProvider>
      {/* </div> */}
    </div>
  );
}

export default App;
